import React, { useState } from 'react'

import { Box, Button, TablePagination, useMediaQuery } from '@material-ui/core'
import { useTheme } from '@material-ui/styles'
import PerfectScrollbar from 'react-perfect-scrollbar'

import { Card, MenuButton } from 'components'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'
import { useSnackbar } from 'hooks'

import * as service from 'service'
import helpers from 'helpers'

const ManageOrganizationsTable = ({
  show,
  ssoCorporateGroupId,
  ssoCorporateGroupOrganizations,
  totalCount,
  handleChangePage,
  handleChangeRowsPerPage,
  page,
  perPage,
  refresh,
}) => {
  const [loading, setLoading] = useState(false)

  const snackbar = useSnackbar()
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  const handleDestroy = async (ssoCorporateGroupOrganizationId) => {
    try {
      setLoading(true)
      await service.dponet.ssoCorporateGroupOrganizations.destroy({
        ssoCorporateGroupId,
        ssoCorporateGroupOrganizationId,
      })
      refresh()
      snackbar.open({
        message: 'Organização desvinculada com sucesso!',
        variant: 'success',
      })
    } catch (error) {
      console.error(error)
      return snackbar.open({
        message: helpers.formatters.errorMessage(
          error?.response?.data?.error || 'Erro ao desvincular organização!',
        ),
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box mt={2} mb={2}>
      <Card title="Grupos Advisor vinculados">
        <PerfectScrollbar
          options={{ wheelPropagation: false, useBothWheelAxes: true }}
        >
          <Table emptyMessage="Nenhuma organização foi encontrado.">
            <TableHead>
              <TableRow>
                <TableCell width="10%">ID </TableCell>
                <TableCell width="40%">Nome</TableCell>
                <TableCell width="40%">Tipo</TableCell>
                {!show && (
                  <TableCell width="10%" align="center">
                    Desvincular
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {ssoCorporateGroupOrganizations?.map(
                (ssoCorporateGroupOrganization) => (
                  <TableRow
                    key={ssoCorporateGroupOrganization?.organization?.id}
                  >
                    <TableCell>
                      {ssoCorporateGroupOrganization?.organization?.id}
                    </TableCell>
                    <TableCell>
                      {ssoCorporateGroupOrganization?.organization?.name}
                    </TableCell>
                    <TableCell>
                      {ssoCorporateGroupOrganization?.organization?.kind ===
                      'DPO'
                        ? 'DPO'
                        : 'Observador'}
                    </TableCell>
                    {!show && (
                      <TableCell align="center" disableTooltip>
                        <MenuButton>
                          <Button
                            disabled={loading}
                            onClick={() =>
                              handleDestroy(ssoCorporateGroupOrganization?.id)
                            }
                          >
                            Desvincular
                          </Button>
                        </MenuButton>
                      </TableCell>
                    )}
                  </TableRow>
                ),
              )}
            </TableBody>
          </Table>
          <Box px={2} display="flex" justifyContent="flex-end">
            <TablePagination
              component="div"
              count={totalCount || 0}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              page={page - 1}
              rowsPerPage={perPage}
              rowsPerPageOptions={[5, 10, 25, 100]}
              labelRowsPerPage={isDesktop ? 'Por página' : ''}
              nextIconButtonProps={{ size: 'small' }}
              backIconButtonProps={{ size: 'small' }}
            />
          </Box>
        </PerfectScrollbar>
      </Card>
    </Box>
  )
}

export default ManageOrganizationsTable
